export const GAME_CONTAINER_ID = "hub88-game-container";

function getGameContainer(): OriginalGamesViewElement | undefined {
  return document
    .getElementById(GAME_CONTAINER_ID)
    ?.getElementsByTagName("game-container")[0] as
    | OriginalGamesViewElement
    | undefined;
}

export default getGameContainer;
